import React from "react"
import styled from "styled-components"

import { theme } from "./mixin"

export default function Count() {
  return (
    <Wrapper>
      <Line1Wrapper>
        {Array.from(new Array(10).keys()).map(() => (
          <>
            <Text>KryptoGO</Text>
            <Text>KryptoGO</Text>
          </>
        ))}
      </Line1Wrapper>
      <Line2Wrapper>
        {Array.from(new Array(10)).map(() => (
          <>
            <Text>KryptoGO</Text>
            <Text>KryptoGO</Text>
          </>
        ))}
      </Line2Wrapper>
    </Wrapper>
  )
}

const Wrapper = styled.div`
  width: 100%;
  background-color: ${theme.bgBlue};
  font-family: ${theme.titleFonts};
  letter-spacing: 3px;
  font-size: 80px;
  overflow: hidden;
  position: relative;
  z-index: 333;
  @keyframes moveRL {
    50% {
      transform: translate(-100%, 0);
    }
  }
  @keyframes moveLR {
    50% {
      transform: translate(100%, 0);
    }
  }
`
const Line1Wrapper = styled.div`
  display: flex;
  justify-content: start;
  gap: 30px;
  animation: moveRL 120s infinite linear;
  color: ${theme.bgBlueText};
  white-space: nowrap;
`
const Line2Wrapper = styled.div`
  display: flex;
  justify-content: end;
  gap: 30px;
  animation: moveLR 120s infinite linear;
  letter-spacing: 0.3px;
  font-weight: 700;
  color: ${theme.bgBlueText};
  white-space: nowrap;
  font-size: 100px;
  margin: -24px 0;
`
const Text = styled.div`
  font-weight: 700;
  color: ${theme.bgBlueText};
  white-space: nowrap;
  letter-spacing: 0.3px;
  @media (${theme.md}) {
    /* padding: 20px 0; */
    font-size: 48px;
  }
`

const TextStroke = styled.div`
  font-weight: 700;
  -webkit-text-stroke: 1px ${theme.secondary}30;
  color: ${theme.bgBlueText}e;
  white-space: nowrap;
`
